(() => {
  let bannerLoad;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-muralora-cookie-preferences]');
    if (!button || button.disabled) return;
    const errorMessage = button.parentElement.querySelector('[data-muralora-cookie-error]');
    button.disabled = true;
    errorMessage.hidden = true;
    try {
      if (!window.privacyBanner?.showPreferences) {
        bannerLoad ||= new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        }).catch((error) => {
          bannerLoad = undefined;
          throw error;
        });
        await bannerLoad;
      }
      await window.privacyBanner.showPreferences();
    } catch {
      errorMessage.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
})();
